import React from 'react'
import { styled } from '@creditas/stylitas'

import { StatusLabel as TStatusLabel } from 'facades/fetchStatusLabel'

import { StatusLabel } from './StatusLabel'
import { useFetchStatusLabel } from './useFetchStatusLabel'

const Container = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  padding-left: 6px;
`

const GroupStatusLabel: React.FC<{
  applicationId: string
  pipelineStatus: string
  cpf: string
}> = ({ applicationId, pipelineStatus, cpf }) => {
  const statusLabels = useFetchStatusLabel(applicationId, pipelineStatus, cpf)

  return (
    <Container data-testid="group-status-label-container">
      {statusLabels &&
        statusLabels.map((label: TStatusLabel, index) => (
          <StatusLabel
            key={index}
            enabled={label.enabled}
            borderColor={label.color}
          >
            <div className="circle" />
            {label.description}
          </StatusLabel>
        ))}
    </Container>
  )
}

export { GroupStatusLabel }
